import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-async-error-handling',
  slug: 'error-handling',
  title: 'The catch that never catches',
  type: 'bug-hunt',
  estSeconds: 420,
  contentVersion: 1,
});
